function ChatSkeleton() {
  return (
    <div className="absolute inset-0 flex bg-secondary h-screen-safe md:static md:h-full">
      {/* Chat List Skeleton */}
      <div className="flex w-full flex-col border-r lg:w-1/3 lg:max-w-[420px]">
        {/* Header Skeleton */}
        <div className="flex h-16 items-center justify-between p-4">
          <div className="h-8 w-44 animate-pulse rounded-md bg-gray-200 dark:bg-gray-700" />
          <div className="size-8 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
        </div>

        {/* Chat List Items Skeleton */}
        <div className="flex-1 overflow-y-auto">
          {[1, 2, 3, 4, 5, 6, 7].map(i => (
            <div key={i} className="flex items-center gap-4 p-4">
              {/* Avatar Skeleton */}
              <div className="size-12 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />

              {/* Chat Info Skeleton */}
              <div className="flex-1 space-y-2">
                <div className="flex justify-between">
                  <div className="h-4 w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
                  <div className="h-4 w-12 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
                </div>
                <div className="h-4 w-48 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Chat View Skeleton */}
      <div className="hidden flex-1 flex-col lg:flex">
        {/* Chat Header Skeleton */}
        <div className="flex h-16 items-center border-b p-4">
          <div className="size-10 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
          <div className="ml-4 h-6 w-32 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        </div>

        {/* Messages Area Skeleton */}
        <div className="flex-1 space-y-4 overflow-y-auto p-4">
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className={`flex ${i % 2 === 0 ? 'justify-end' : 'justify-start'}`}>
              <div className="max-w-[75%] space-y-2">
                <div className="h-16 w-64 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
                <div className="h-4 w-16 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
              </div>
            </div>
          ))}
        </div>

        {/* Input Area Skeleton */}
        <div className="m-2 flex items-center rounded-full border p-1">
          <div className="size-8 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
          <div className="mx-2 h-8 w-full animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
          <div className="size-8 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
        </div>
      </div>
    </div>
  );
}

export default ChatSkeleton;
